export default {
    install(Vue) {
        Vue.mixin({
            computed: {
                isMobile() {
                    return window.innerWidth <= 768
                }
            },
            mounted() {
                this._lastIsMobile = this.isMobile1; // 初始化为当前状态
                // console.log("🚀 ~ mounted ~ isMobile:", this.isMobile1, this._lastIsMobile);
                this.debounceResize = this.debounce(this.checkResize, 300);
                window.addEventListener('resize', this.debounceResize);
            },
            beforeDestroy() {
                window.removeEventListener('resize', this.debounceResize);
            },
            methods: {
                debounce(func, wait) {
                    let timeout;
                    return function (...args) {
                        clearTimeout(timeout);
                        this.isMobile1 = window.innerWidth <= 768
                        timeout = setTimeout(() => func.apply(this, args), wait);
                    };
                },
                checkResize() {
                    // console.log("🚀 ~ checkResize ~ isMobile:", this.isMobile1, this._lastIsMobile);
                    const currentIsMobile = this.isMobile;
                    // 检查是否真正跨越了 768px 的阈值
                    if ((this._lastIsMobile && !currentIsMobile) || (!this._lastIsMobile && currentIsMobile)) {
                        this.refreshPage();
                    }

                },
                refreshPage() {
                    window.location.reload();
                },
            },
            data() {
                return {
                    isMobile1: window.innerWidth <= 768,
                    _lastIsMobile: null,
                };
            },
        });
    }
};
